import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { BigFiveResult } from '@models/big-five/big-five-result';
import { Store } from '@ngrx/store';
import { selectBigFiveResults } from '@stores/big-five/big-five.selectors';

export const bigFiveResultsResolver: ResolveFn<BigFiveResult[] | null> = () =>
  inject(Store).select(selectBigFiveResults);
